<template>
  <div name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container d-flex flex-column h-full">
          <TopAppBar
            :leftBtnMode="leftBtnMode"
            :rightBtnMode="rightBtnMode"
            :title="title"
            :leftBtnMethod="leftBtnMethod"
            :rightBtnMethod="rightBtnMethod"
            staticMode="true"
          >
          </TopAppBar>
          <div class="flex-grow-1 scroll-y">
            <div class="pda-default">
              <div class="t-subtitle2">
                {{ $t('S10072') }}
              </div>

              <div class="mgt-16">
                <div :class="{'mdc-select--disabled': defaultPrivacy}" class="mdc-select mdc-select--outlined w-full" id="selectNation">
                  <i class="mdc-select__dropdown-icon select-icon-custom"></i>
                  <select v-if="defaultPrivacy" class="mdc-select__native-control" name="privacy" v-model="privacyUrlIframe">
                    <option selected disabled value="">
                      {{ $moment(this.baseDate).format('L') }}
                    </option>
                  </select>
                  <select v-else class="mdc-select__native-control" name="privacy" v-model="privacyUrlIframe" @change="onChanged($event)">
                    <option selected disabled value="">
                      {{ $moment(this.baseDate).format('L') }}
                    </option>
                    <option v-for="(privacy, index) in privacyList" :key="index" :value="privacy.attachment.resourceUri">
                      {{ $moment(privacy.baseDate).format('L') }}
                    </option>
                  </select>
                  <div class="mdc-notched-outline">
                    <div class="mdc-notched-outline__leading"></div>
                    <div class="mdc-notched-outline__notch">
                    </div>
                    <div class="mdc-notched-outline__trailing"></div>
                  </div>
                </div>
              </div>
              <div class="divider mgt-24"></div>
              <div class="mgt-24 flex-grow-1 h-full">
                  <div
                    class="t-body3 t-color-content1"
                    v-html="htmlPrivacypolicy"
                  ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 개인정보 취급방침 컴포넌트(Privacy Policy Components)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import { topAppBarMixin } from "@/mixins/topAppBar.js";
import TopAppBar from "@/components/TopAppBar.vue";
import joinApi from "@/api/joinApi.js";

export default {
  components: {
    TopAppBar,
  },

  data() {
    return {
      title: this.$t("1601"),
      defaultPrivacy: false,
      baseDate: new Date(),
      privacyList: [],
      privacyUrlIframe: '',
      htmlPrivacypolicy: null
    };
  },

  mixins: [topAppBarMixin],

  mounted() {
    this.setTopAppBarCloseOnly(this.title);
    this.fetchData();
  },

  methods: {
    fetchData() {
      joinApi.termsList().then((response) => {
        this.privacyList = response.data.data.PRIVACY_STATEMENT;
        this.htmlPrivacypolicy = this.privacyList[0].attachment.resourceUri;
        this.baseDate = this.privacyList[0].baseDate;

        if(this.privacyList.length <= 1) {
          this.defaultPrivacy = true;
        }
        this.fetchContent(this.htmlPrivacypolicy);
      })
    },

    fetchContent(data) {
      joinApi.policyContents(data, "text").then((response) => {
        this.htmlPrivacypolicy = response.data;
      });
    },

    onChanged() {
      const termsUrl = event.target.value;
      this.fetchContent(termsUrl);
    }
  }
};
</script>
